import { create } from 'zustand';

interface Candidate {
  submittedInterviewId: string;
  candidateName: string;
  completedOnUtc: string;
  forReview: number;
  pickAndChooseCorrect: number | null;
  pickAndChooseTotal: number;
  status: number;
  totalTime: number;
  deadline: string;
}

interface CandidateStore {
  selectedCandidate: Candidate | null;
  currentInterviewId: string | null;
  currentQuestionIndex: number;
  setSelectedCandidate: (candidate: Candidate, interviewId: string) => void;
  clearSelectedCandidate: () => void;
  setCurrentQuestionIndex: (index: number) => void;
}

export const useCandidateStore = create<CandidateStore>((set) => ({
  selectedCandidate: null,
  currentInterviewId: null,
  currentQuestionIndex: 0,
  setSelectedCandidate: (candidate, interviewId) => set({ selectedCandidate: candidate, currentInterviewId: interviewId }),
  clearSelectedCandidate: () => set({ selectedCandidate: null, currentInterviewId: null, currentQuestionIndex: 0 }),
  setCurrentQuestionIndex: (index) => set({ currentQuestionIndex: index }),
})); 